module.exports = __webpack_public_path__ + "img/Big Picture Thinker.3ef97e35.svg";